<template>
    <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i
            class="material-icons"
            id="menu-toggle"
            @click="isSidebar =  !isSidebar"
            style="cursor:pointer"
            >view_headline</i
          >
          <app-navbar></app-navbar>
          <div class="container-fluid mt-5">
            <div class="col-sm-12">
              <div class="row dblock">
                <div class="row">
                  <div class="col-md-12">
                    <vs-breadcrumb
                      align="left"
                      :items="
                    [
                      {title: 'You are here : '},
                      {
                        title: 'Events Report',
                        active: true
                      }
                    ]"
                    ></vs-breadcrumb>
                    <div class="heading mt-3">
                      <h3 class="text-secondary">Events Report</h3>
                    </div>
                  </div>
                </div>
              </div>
              <!-- -->
              <TrainingReport />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TrainingReport from "../../commonPages/TrainingReport"
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  
  
  export default {
    data: () => ({
      isSidebar: false,
  
    }),
  
    components: {
      "app-navbar": Navbar,
      "app-sidebar": Sidebar,
       TrainingReport
    },
  
  };
  </script>
  
  <style scoped>
  
  .myNavbar {
    color: rgb(255, 255, 255);
  }
  
  @media (max-width: 768px) {
  
  }
  </style>
  